module.exports = __webpack_public_path__ + "static/media/Zgrada1.eb4f168c.png";